import { assert_array_not_includes, assert_equal, assert_false, assert_true } from '@shared/asserts/utils_asserts';
import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { UTILS__array } from '@shared/utils/utils_array';
import { FIELD__base } from '../../_fields/_base/FIELD__base';
import { DTO_GRAPH__instance } from '../DTO_GRAPH__instance';

declare module '../DTO_GRAPH__instance' {
  interface DTO_GRAPH__instance {
    /*
     *
     */

    /*
     *
     */

    field_source__link(field_from: FIELD__base, field_to: FIELD__base): void;

    field_source__unlink(field_from: FIELD__base, field_to: FIELD__base): void;
  }
}

export function INIT_EXTENSION_DTO_GRAPH__instance_sync_values() {
  // do nothing
}

/*
 *
 */

DTO_GRAPH__instance.prototype.field_source__link = function (field_from: FIELD__base, field_to: FIELD__base): void {
  let [field_from__id, field_to__id] = [field_from.meta.field_id, field_to.meta.field_id];
  /*
   *
   */
  field_to.meta.data__is_linked = true;

  /*
   * CHILDREN
   */

  let fields_children = field_to.fields__get_map(true).values();

  let edges_related_to_children = this.edges__get_related_to_fields(fields_children);
  this.edges__delete(edges_related_to_children);

  for (let field of fields_children) {
    field.meta.data__synced_by_parent_id = field_to.meta.field_id;
    field.meta.data__is_linked = true;
  }

  /*
   *
   */

  assert_false(this.fields_ids_map__by_target_id.has(field_to__id));

  this.fields_ids_map__by_target_id.set(field_to__id, field_from__id);

  /*
   *
   */

  let fields_ids_targets = this.fields_ids_map__by_source_id.get_or_create_array(field_from__id);

  assert_array_not_includes(fields_ids_targets, field_to__id);

  fields_ids_targets.push(field_to__id);
};

DTO_GRAPH__instance.prototype.field_source__unlink = function (field_from: FIELD__base, field_to: FIELD__base): void {
  let [field_from__id, field_to__id] = [field_from.meta.field_id, field_to.meta.field_id];

  /*
   *
   */
  field_to.meta.data__is_linked = false;

  /*
   * CHILDREN
   */
  let fields_children = field_to.fields__get_map(true).values();

  for (let field of fields_children) {
    field.meta.data__synced_by_parent_id = ENUM__string_id_empty.UUID;
    field.meta.data__is_linked = false;
  }

  /*
   * BY SOURCE
   */

  let fields_ids_targets = this.fields_ids_map__by_source_id.get_or_assert(field_from__id);
  assert_true(fields_ids_targets.includes(field_to__id));

  UTILS__array.delete_value(fields_ids_targets, field_to__id);

  if (fields_ids_targets.is_empty()) this.fields_ids_map__by_source_id.delete(field_from__id);

  /*
   * BY TARGET
   */

  let field_from__id__from_map = this.fields_ids_map__by_target_id.get_or_assert(field_to__id);
  assert_equal(field_from__id__from_map, field_from__id);

  this.fields_ids_map__by_target_id.delete(field_to__id);
};
